export const IS_USER_AUTHENTICATED_GETTER = "[getters] is user autenticated";

import {
  LOGIN_ACTION,
  AUTH_ACTION,
  SWITCH_LEVEL_ACTION,
  LOGOUT_ACTION,
  SET_USER_TOKEN_DATA_MUTATION,
  AUTO_LOGIN_ACTION,
  AUTO_LOGOUT_ACTION,
  SET_AUTO_LOGOUT_MUTATION,
  SET_IMAGE_MUTATION,
  AUTO_IMAGE_ACTION,
  IMAGE_ACTION,
  SET_EDITION_MUTATION,
  AUTO_EDITION_ACTION,
  EDITION_ACTION,
  AUTO_IDTOCANCEL_ACTION,
  IDTOCANCEL_ACTION,
  AUTO_FRRID_ACTION,
  FRRID_ACTION,
  SET_FRRID_MUTATION,
  AUTO_TEAMACTIONS_ACTION,
  TEAMACTIONS_ACTION,
  SET_TEAMACTIONS_MUTATION,
  AUTO_SECTION_ACTION,
  SET_SECTION_MUTATION,
  SECTION_ACTION,
  AUTO_TRDETAILS_ACTION,
  SET_TRDETAILS_MUTATION,
  TRDETAILS_ACTION,
  AUTO_TRID_ACTION,
  SET_TRID_MUTATION,
  TRID_ACTION,
  AUTO_TROBSERVATIONS_ACTION,
  TROBSERVATIONS_ACTION,
  SET_TROBSERVATIONS_MUTATION,
  AUTO_PLID_ACTION,
  SET_PLID_MUTATION,
  PLID_ACTION,
  AUTO_PLOBSERVATIONS_ACTION,
  SET_PLOBSERVATIONS_MUTATION,
  PLOBSERVATIONS_ACTION,
  AUTO_VDOBSERVATIONS_ACTION,
  SET_VDOBSERVATIONS_MUTATION,
  VDOBSERVATIONS_ACTION,
  AUTO_VDID_ACTION,
  SET_VDID_MUTATION,
  VDID_ACTION,
  AUTO_FPOBSERVATIONS_ACTION,
  SET_FPOBSERVATIONS_MUTATION,
  FPOBSERVATIONS_ACTION,
  AUTO_ID_ACTION,
  ID_ACTION,
  SET_ID_MUTATION,
  AUTO_OBSERVATIONS_ACTION,
  OBSERVATIONS_ACTION,
  SET_OBSERVATIONS_MUTATION,
  SET_EXPIRES_AT,
  SET_EXPIRY_WARNING,
  SET_COUNTDOWN,
  RESET_WARNING,
} from "../../storeconstants";

import axios from "axios";

let timer = null; // auto-logout
let warningTimer = null; // fires at T-5s
let countdownInterval = null; // ticks the countdown

const WARNING_MS = 120_000; // TEST: change value
const API_BASE = "https://eurocscoringapi.duartecota.pt";

const normalizeAvatar = (img) => {
  const value = String(img || "").trim().replace(/\\/g, "/");
  if (!value || ["null", "undefined"].includes(value.toLowerCase())) return "";
  if (value.includes("/img/avatar.png")) return "";
  if (/^https?:\/\//i.test(value)) return value.replace(/^http:\/\//i, "https://");
  if (value.startsWith("//")) return `https:${value}`;
  return `${API_BASE}/${value.replace(/^\/+/, "")}`;
};

const safeStorage = {
  getItem(key) {
    try {
      return typeof localStorage === "undefined" ? null : localStorage.getItem(key);
    } catch (error) {
      console.warn(`[auth] Could not read ${key} from localStorage`, error);
      return null;
    }
  },
  setItem(key, value) {
    try {
      if (typeof localStorage !== "undefined") localStorage.setItem(key, value);
      return true;
    } catch (error) {
      console.warn(`[auth] Could not save ${key} to localStorage`, error);
      return false;
    }
  },
  removeItem(key) {
    try {
      if (typeof localStorage !== "undefined") localStorage.removeItem(key);
    } catch (error) {
      console.warn(`[auth] Could not remove ${key} from localStorage`, error);
    }
  },
};

export default {
  [LOGOUT_ACTION](context) {
    context.commit(SET_USER_TOKEN_DATA_MUTATION, {
      userID: null,
      firstname: null,
      lastname: null,
      levelID: null,
      token: null,
      img: null,
      expiresIn: null,
      tebID: null,
      tebName: null,
      edition: null,
    });
    safeStorage.removeItem("userData");
    if (timer) {
      clearTimeout(timer);
    }
    // reset session warning/countdown
    context.commit(RESET_WARNING);
    context.commit(SET_EXPIRES_AT, 0);
    return true;
  },

  [AUTO_LOGIN_ACTION](context) {
    const str = safeStorage.getItem("userData");
    if (!str) return;

    let userData = null;
    try {
      userData = JSON.parse(str);
    } catch (error) {
      safeStorage.removeItem("userData");
      return;
    }
    userData.img = normalizeAvatar(userData.img);
    safeStorage.setItem("userData", JSON.stringify(userData));
    const expiresAt = userData.expiresAt || 0;
    const remainingMs = expiresAt - Date.now();
    if (remainingMs <= 0) {
      context.dispatch(AUTO_LOGOUT_ACTION);
      return;
    }

    context.commit(SET_USER_TOKEN_DATA_MUTATION, userData);

    // clear old stuff
    if (timer) clearTimeout(timer);
    if (warningTimer) clearTimeout(warningTimer);
    if (countdownInterval) clearInterval(countdownInterval);
    timer = warningTimer = countdownInterval = null;

    // auto-logout at expiry
    timer = setTimeout(() => context.dispatch(AUTO_LOGOUT_ACTION), remainingMs);

    // kickoff at T-5s (or immediately if <5s remain)
    const kickoffDelay = Math.max(remainingMs - WARNING_MS, 0);
    warningTimer = setTimeout(() => {
      context.commit(SET_EXPIRY_WARNING, true);

      // initialize to min(remaining, 5)
      const initSecs = Math.max(Math.ceil((expiresAt - Date.now()) / 1000), 0);
      context.commit(SET_COUNTDOWN, Math.min(initSecs, WARNING_MS / 1000));

      // tick to 0
      const tick = () => {
        const s = Math.max(Math.ceil((expiresAt - Date.now()) / 1000), 0);
        context.commit(SET_COUNTDOWN, s);
        if (s <= 0 && countdownInterval) {
          clearInterval(countdownInterval);
          countdownInterval = null;
        }
      };
      tick();
      countdownInterval = setInterval(tick, 1000);
    }, kickoffDelay);

    context.commit(SET_EXPIRES_AT, expiresAt);
  },

  [AUTO_LOGOUT_ACTION](context) {
    context.dispatch(LOGOUT_ACTION);
    context.commit(SET_AUTO_LOGOUT_MUTATION);
  },

  /*async [AUTH_ACTION](context, payload) {
    let postData = {
      username: payload.username,
      password: payload.password,
      editionyear: payload.editionyear,
    };
    safeStorage.setItem("edition", payload.editionyear);
    let response = await axios.post(payload.url, postData);
    if (response.data.code === "userfound") {
      //let expirationTime = response.data.body.expiresIn * 1000;
      let expiresInMs = 20 * 1000;
      let expiresAt = Date.now() + expiresInMs;

      timer = setTimeout(() => {
        context.dispatch(AUTO_LOGOUT_ACTION);
      }, expiresInMs);

      // --- start the 2-minute warning (use 5s for testing) ---
      const WARNING_MS = 5_000; // set to 120_000 in real use
      const kickoffDelay = Math.max(expiresInMs - WARNING_MS, 0);
      console.log("[AUTH] warning in", kickoffDelay, "ms");
      setTimeout(() => {
        console.log("[AUTH] warning fired; starting countdown");
        context.commit(SET_EXPIRY_WARNING, true);
        const tick = () => {
          const s = Math.max(Math.ceil((expiresAt - Date.now()) / 1000), 0);
          console.log("[AUTH] countdown tick", s, "s left");
          context.commit(SET_COUNTDOWN, s);
          if (s <= 0) clearInterval(interval);
        };
        tick();
        const interval = setInterval(tick, 1000);
      }, kickoffDelay);
      // --- end warning ---

      const img = normalizeAvatar(response.data.body.img);
      let tokenData = {
        userID: response.data.body.userID,
        firstname: response.data.body.firstname,
        lastname: response.data.body.lastname,
        email: response.data.body.email,
        levelID: response.data.body.levelID,
        level: response.data.body.level,
        img: img,
        //expiresIn: expirationTime,
        expiresIn: expiresInMs,
        expiresAt, // new
        token: response.headers.authorization,
        tebID: response.data.body.tebID,
        tebName: response.data.body.tebName,
        edition: payload.editionyear, //new
      };
      localStorage.setItem("userData", JSON.stringify(tokenData));
      context.commit(SET_USER_TOKEN_DATA_MUTATION, tokenData);
      context.commit(SET_EXPIRES_AT, expiresAt);
      return response;
    } else return response;
  },*/

  // Full AUTH_ACTION
  async [AUTH_ACTION](context, payload) {
    const postData = {
      username: payload.username,
      password: payload.password,
      editionyear: payload.editionyear,
    };
    if (payload.levelID) {
      postData.levelID = payload.levelID;
    }
    safeStorage.setItem("edition", payload.editionyear);

    const response = await axios.post(payload.url, postData);
    if (response.data.code !== "userfound") return response;

    // timing (backend already returns ms)
    let expiresInMs = response.data.body.expiresIn; // ms
    //let expiresInMs = 60000;
    const expiresAt = Date.now() + expiresInMs;

    // clear old timers
    if (timer) clearTimeout(timer);
    if (warningTimer) clearTimeout(warningTimer);
    if (countdownInterval) clearInterval(countdownInterval);
    timer = warningTimer = countdownInterval = null;

    // auto-logout
    timer = setTimeout(() => context.dispatch(AUTO_LOGOUT_ACTION), expiresInMs);

    // kickoff at T-5s (or immediately if <5s)
    const kickoffDelay = Math.max(expiresInMs - WARNING_MS, 0);
    warningTimer = setTimeout(() => {
      context.commit(SET_EXPIRY_WARNING, true);

      // initialize to min(remaining, 5)
      const initSecs = Math.max(Math.ceil((expiresAt - Date.now()) / 1000), 0);
      context.commit(SET_COUNTDOWN, Math.min(initSecs, WARNING_MS / 1000));

      // tick to 0
      const tick = () => {
        const s = Math.max(Math.ceil((expiresAt - Date.now()) / 1000), 0);
        context.commit(SET_COUNTDOWN, s);
        if (s <= 0 && countdownInterval) {
          clearInterval(countdownInterval);
          countdownInterval = null;
        }
      };
      tick();
      countdownInterval = setInterval(tick, 1000);
    }, kickoffDelay);

    // build token data
    const img = normalizeAvatar(response.data.body.img);

    const tokenData = {
      userID: response.data.body.userID,
      firstname: response.data.body.firstname,
      lastname: response.data.body.lastname,
      email: response.data.body.email,
      levelID: response.data.body.levelID,
      level: response.data.body.level,
      availableLevels: response.data.body.availableLevels || [],
      img,
      expiresIn: expiresInMs, // keep ms
      expiresAt, // absolute ms
      token: response.headers.authorization,
      tebID: response.data.body.tebID,
      tebName: response.data.body.tebName,
      edition: payload.editionyear,
    };

    safeStorage.setItem("userData", JSON.stringify(tokenData));
    context.commit(SET_USER_TOKEN_DATA_MUTATION, tokenData);
    context.commit(SET_EXPIRES_AT, expiresAt);

    return response;
  },

  async [LOGIN_ACTION](context, payload) {
    return context.dispatch(AUTH_ACTION, {
      ...payload,
      url: "https://eurocscoringapi.duartecota.pt/auth",
    });
  },

  async [SWITCH_LEVEL_ACTION](context, payload) {
    const editionyear =
      payload.editionyear ||
      context.state.edition ||
      safeStorage.getItem("edition");
    const response = await axios.put(
      "https://eurocscoringapi.duartecota.pt/auth/level",
      {
        levelID: payload.levelID,
        editionyear,
      },
      {
        headers: { Authorization: context.state.token },
      },
    );

    if (response.data.code !== "levelswitched") return response;

    const expiresInMs = response.data.body.expiresIn;
    const expiresAt = Date.now() + expiresInMs;

    if (timer) clearTimeout(timer);
    if (warningTimer) clearTimeout(warningTimer);
    if (countdownInterval) clearInterval(countdownInterval);
    timer = warningTimer = countdownInterval = null;

    timer = setTimeout(() => context.dispatch(AUTO_LOGOUT_ACTION), expiresInMs);

    const kickoffDelay = Math.max(expiresInMs - WARNING_MS, 0);
    warningTimer = setTimeout(() => {
      context.commit(SET_EXPIRY_WARNING, true);

      const initSecs = Math.max(Math.ceil((expiresAt - Date.now()) / 1000), 0);
      context.commit(SET_COUNTDOWN, Math.min(initSecs, WARNING_MS / 1000));

      const tick = () => {
        const s = Math.max(Math.ceil((expiresAt - Date.now()) / 1000), 0);
        context.commit(SET_COUNTDOWN, s);
        if (s <= 0 && countdownInterval) {
          clearInterval(countdownInterval);
          countdownInterval = null;
        }
      };
      tick();
      countdownInterval = setInterval(tick, 1000);
    }, kickoffDelay);

    const img = normalizeAvatar(response.data.body.img);

    const tokenData = {
      userID: response.data.body.userID,
      firstname: response.data.body.firstname,
      lastname: response.data.body.lastname,
      email: response.data.body.email,
      levelID: response.data.body.levelID,
      level: response.data.body.level,
      availableLevels: response.data.body.availableLevels || [],
      img,
      expiresIn: expiresInMs,
      expiresAt,
      token: response.headers.authorization || response.data.body.token,
      tebID: response.data.body.tebID,
      tebName: response.data.body.tebName,
      edition: editionyear,
    };

    safeStorage.setItem("edition", editionyear);
    safeStorage.setItem("userData", JSON.stringify(tokenData));
    context.commit(SET_USER_TOKEN_DATA_MUTATION, tokenData);
    context.commit(SET_EXPIRES_AT, expiresAt);
    context.commit(RESET_WARNING);

    return response;
  },

  //image
  async [AUTO_IMAGE_ACTION](context, payload) {
    return context.dispatch(IMAGE_ACTION, {
      ...payload,
    });
  },
  [IMAGE_ACTION](context, payload) {
    context.commit(SET_IMAGE_MUTATION, payload);
  },

  //edition
  async [AUTO_EDITION_ACTION](context, payload) {
    return context.dispatch(EDITION_ACTION, {
      ...payload,
    });
  },
  [EDITION_ACTION](context, payload) {
    context.commit(SET_EDITION_MUTATION, payload);
  },

  //cancel id
  async [AUTO_IDTOCANCEL_ACTION](context, payload) {
    return context.dispatch(EDITION_ACTION, {
      ...payload,
    });
  },
  [IDTOCANCEL_ACTION](context, payload) {
    context.commit(SET_EDITION_MUTATION, payload);
  },

  //FRR id
  async [AUTO_FRRID_ACTION](context, payload) {
    return context.dispatch(FRRID_ACTION, {
      ...payload,
    });
  },
  [FRRID_ACTION](context, payload) {
    context.commit(SET_FRRID_MUTATION, payload);
  },

  // TR observations
  async [AUTO_TRID_ACTION](context, payload) {
    return context.dispatch(TRID_ACTION, {
      ...payload,
    });
  },
  [TRID_ACTION](context, payload) {
    context.commit(SET_TRID_MUTATION, payload);
  },

  //Payload
  async [AUTO_PLID_ACTION](context, payload) {
    return context.dispatch(PLID_ACTION, {
      ...payload,
    });
  },
  [PLID_ACTION](context, payload) {
    context.commit(SET_PLID_MUTATION, payload);
  },

  //Payload
  async [AUTO_VDID_ACTION](context, payload) {
    return context.dispatch(VDID_ACTION, {
      ...payload,
    });
  },
  [VDID_ACTION](context, payload) {
    context.commit(SET_VDID_MUTATION, payload);
  },

  //Team actions
  async [AUTO_TEAMACTIONS_ACTION](context, payload) {
    return context.dispatch(TEAMACTIONS_ACTION, {
      ...payload,
    });
  },
  [TEAMACTIONS_ACTION](context, payload) {
    context.commit(SET_TEAMACTIONS_MUTATION, payload);
  },

  //Technical Report observations
  async [AUTO_TROBSERVATIONS_ACTION](context, payload) {
    return context.dispatch(TROBSERVATIONS_ACTION, {
      ...payload,
    });
  },
  [TROBSERVATIONS_ACTION](context, payload) {
    context.commit(SET_TROBSERVATIONS_MUTATION, payload);
  },

  //Payload observations
  async [AUTO_PLOBSERVATIONS_ACTION](context, payload) {
    return context.dispatch(PLOBSERVATIONS_ACTION, {
      ...payload,
    });
  },
  [PLOBSERVATIONS_ACTION](context, payload) {
    context.commit(SET_PLOBSERVATIONS_MUTATION, payload);
  },

  //Vehicle Design observations
  async [AUTO_VDOBSERVATIONS_ACTION](context, payload) {
    return context.dispatch(VDOBSERVATIONS_ACTION, {
      ...payload,
    });
  },
  [VDOBSERVATIONS_ACTION](context, payload) {
    context.commit(SET_VDOBSERVATIONS_MUTATION, payload);
  },

  //Flight Performance observations
  async [AUTO_FPOBSERVATIONS_ACTION](context, payload) {
    return context.dispatch(FPOBSERVATIONS_ACTION, {
      ...payload,
    });
  },
  [FPOBSERVATIONS_ACTION](context, payload) {
    context.commit(SET_FPOBSERVATIONS_MUTATION, payload);
  },

  //Section
  async [AUTO_SECTION_ACTION](context, payload) {
    return context.dispatch(SECTION_ACTION, {
      ...payload,
    });
  },
  [SECTION_ACTION](context, payload) {
    context.commit(SET_SECTION_MUTATION, payload);
  },

  //TR details
  async [AUTO_TRDETAILS_ACTION](context, payload) {
    return context.dispatch(TRDETAILS_ACTION, {
      ...payload,
    });
  },
  [TRDETAILS_ACTION](context, payload) {
    context.commit(SET_TRDETAILS_MUTATION, payload);
  },

  /* teste */
  async [AUTO_ID_ACTION](context, payload) {
    return context.dispatch(ID_ACTION, {
      ...payload,
    });
  },
  [ID_ACTION](context, payload) {
    context.commit(SET_ID_MUTATION, payload);
  },
  async [AUTO_OBSERVATIONS_ACTION](context, payload) {
    return context.dispatch(OBSERVATIONS_ACTION, {
      ...payload,
    });
  },
  [OBSERVATIONS_ACTION](context, payload) {
    context.commit(SET_OBSERVATIONS_MUTATION, payload);
  },
};
